import React from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { Box, Flex, Text } from "rebass";
import get from "lodash/get";

import { getUser } from "../../../store/modules/session/selectors";

import { NavLink } from "./NavLink";
import { isAccountActive } from "./NavLink/isAccountActive"
import { LinkSection } from "./LinksSection";
import { links as preferencesLinks } from "./Preferences";
import { links as youAndUsLinks } from "./YouAndUs";

import { UserIcon } from "../../components/UserIcon";
import { ProfileSVG } from "../../components/svg/ProfileSVG";
import { Scrollbar } from "../../components/Scrollbar";
import { SignOutSVG } from "../../components/svg/SignOutSVG";

import packages from "../../../../package.json";

interface IProps extends Pick<RouteComponentProps, "match"> {
  isLogin: boolean;
}

const publicSections = [
  { title: "You and Us", links: youAndUsLinks, },
  { title: "Preferences", links: preferencesLinks, },
];

export const Aside: React.FC<IProps> = ({ match, isLogin }) => {
  const user = useSelector(getUser);
  const hasPhotoURL = Boolean(get(user, ["photoURL"]));
  const sections = [
    ...publicSections,
  ];

  return (
    <Flex
      height="100%"
      flexDirection="column"
      css="overflow: hidden;"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        p="25px"
      >
        <Text
          fontSize="30px"
          fontWeight="bold"
          color="#2b3160"
          css="text-transform: capitalize;"
        >
          settings
        </Text>

        {
          hasPhotoURL && <UserIcon />
        }
      </Flex>

      <Box
        flex={1}
        css="overflow: hidden;"
      >
        <Scrollbar>
          <NavLink
            to={location => ({ ...location, pathname: `${match.url}/${isLogin ? "account" : "sign-in"}` })}
            isActive={isAccountActive}
            color="sp-blue"
            title={isLogin ? "Account" : "Sign In"}
            Icon={ProfileSVG}
          />

          {
            sections.map(({ title, links }) => (
              <LinkSection
                key={title}
                links={links}
                title={title}
                url={match.url}
              />
            ))
          }

          {
            isLogin && (
              <Box pt="18px">
                <NavLink
                  to={`${match.url}/sign-out`}
                  color="orange"
                  title="Sign Out"
                  Icon={SignOutSVG}
                />
              </Box>
            )
          }
        </Scrollbar>
      </Box>

      <Text
        as="p"
        p="4px"
        fontSize={1}
        color="wild-blue"
        textAlign="right"
      >
        {`v${packages.version}`}
      </Text>
    </Flex>
  );
};
